import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

export default function About() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50">
      <Navigation />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl p-8 mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">About Female Fitness Finder</h1>
          <div className="prose prose-lg max-w-none text-gray-600">
            <p className="mb-4">
              Female Fitness Finder was born from a simple observation: women deserve fitness solutions that truly understand their unique needs, goals, and challenges. We're more than just a platform - we're a movement dedicated to empowering women through fitness.
            </p>
            <p className="mb-4">
              Our mission is to create a supportive, inclusive environment where women can discover the perfect fitness programs, connect with expert trainers, and join communities that celebrate their journey toward health and wellness.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-8">
          <div className="bg-white rounded-xl p-6">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Our Mission</h2>
            <p className="text-gray-600">
              To empower women to achieve their fitness goals by providing personalized, accessible, and supportive fitness solutions that adapt to their unique lifestyles and needs.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Our Vision</h2>
            <p className="text-gray-600">
              To become the leading platform connecting women with fitness resources, creating a global community where every woman feels supported in her health and wellness journey.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-2xl p-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Why Choose Us?</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Verified Experts</h3>
              <p className="text-gray-600">All trainers are certified and experienced in women's fitness</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-pink-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Personalized Approach</h3>
              <p className="text-gray-600">Programs tailored to your specific goals and body type</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Supportive Community</h3>
              <p className="text-gray-600">Connect with women on similar fitness journeys</p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
